import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  AfterViewInit,
  ElementRef
} from '@angular/core';

@Component({
  selector: 'bepatient-right-wrong-popup',
  templateUrl: './right-wrong-popup.component.html',
  styleUrls: ['./right-wrong-popup.component.scss'],
  standalone: false
})
export class RightWrongPopupComponent implements AfterViewInit {
  @ViewChild('container', { read: ElementRef, static: true })
  container: ElementRef;

  @Input() message: string;
  @Input() correct: boolean;
  @Input() title: string;
  @Input() buttonLabel: string;

  @Output() validated = new EventEmitter<boolean>();

  ngAfterViewInit() {
    const scrollableContainer =
      this.container.nativeElement.parentElement.parentElement;
    scrollableContainer.scrollTop = 0;
  }
}
